import useTotalBalance from '@/ui/hooks/use-total-balance';
import useWidgetConfig from '@/ui/hooks/use-widget-config';
import { cn } from '@/ui/utils/classnames';
import { expandWidget } from '@/ui/utils/widget-size';
import {
  COLLAPSED_DIMENSIONS_BY_SIZE,
  COLLAPSED_SQUARED_BORDER_RADIUS_BY_SIZE,
  COLLAPSED_COMPACT_BORDER_RADIUS,
} from './constants.js';
import Avatar from './parts/avatar.js';
import ExpandIcon from './parts/expand-icon.js';
import FancyAmountSkeleton from './parts/fancy-amount-skeleton.js';
import FancyAmount from './parts/fancy-amount.js';

function WalletSnapshot() {
  const { value: balance, loading } = useTotalBalance();

  const {
    shape,
    size,
    compact: compactOverride,
    noAutoCompact,
    smallScreen,
  } = useWidgetConfig();

  const compact = compactOverride || (smallScreen && !noAutoCompact);

  const dimensions = COLLAPSED_DIMENSIONS_BY_SIZE[size];
  const borderRadius =
    shape === 'rounded'
      ? dimensions.height / 2
      : compact
        ? COLLAPSED_COMPACT_BORDER_RADIUS
        : COLLAPSED_SQUARED_BORDER_RADIUS_BY_SIZE[size];

  // ATTENTION: Keep layout consistent with loading state in `index.html`.
  return (
    <button
      className={cn(
        'flex size-full items-center',
        'shadow-[inset_0_0_0_1px_var(--collapsed-border-color,_theme(colors.gray.200))]',
        'bg-[color:var(--collapsed-bg-color,_theme(colors.gray.100))]',
        size === 'small' && !compact && 'gap-x-1 p-1 pr-2',
        size === 'medium' && !compact && 'gap-x-1 p-1.5 pr-2.5',
        size === 'large' && !compact && 'gap-x-1 p-2 pr-3',
        size === 'huge' && !compact && 'gap-x-3 p-3 pr-5',
        compact && 'p-1',
      )}
      style={{
        borderRadius: `${borderRadius}px`,
      }}
      onClick={expandWidget}
      type="button"
    >
      <Avatar shape={shape} size={size === 'huge' ? 36 : 24} />
      {!compact && (
        <>
          {loading ? (
            <FancyAmountSkeleton />
          ) : (
            <FancyAmount
              className="flex-1"
              fontSize={size === 'huge' ? 28 : 18}
              value={balance.toDefaultNumber()}
            />
          )}
          <ExpandIcon size={size === 'huge' ? 32 : 16} />
        </>
      )}
    </button>
  );
}

export default WalletSnapshot;
